<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconStar_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="m14.773 5.86-4.28-.622L8.579 1.36a.646.646 0 0 0-1.158 0L5.507 5.238l-4.28.622a.646.646 0 0 0-.358 1.102l3.097 3.019-.731 4.263a.646.646 0 0 0 .937.681L8 12.912l3.828 2.013a.646.646 0 0 0 .937-.681l-.731-4.263 3.097-3.019a.646.646 0 0 0-.358-1.102"
    />
</svg>
